import { FullScreenLoader } from '@components/Fillers/FullScreenLoader'
import { useOrg } from '@features/organizations/hooks/useOrganizations'
import styles from '@layouts/shared-styles'
import React from 'react'
import { ScrollView } from 'react-native'
import { createParam } from 'solito'
import { GiveMoreDetails } from '~/features/organizations/screens/GiveMoreDetails'

const { useParam } = createParam<{ alias: string }>()

export function GiveMoreScreen() {
  const [aliasOrValias] = useParam('alias', {
    initial: '',
  })

  const screenQuery = useOrg(aliasOrValias)

  if (screenQuery.isLoading || screenQuery.isLoadingError || !aliasOrValias)
    return <FullScreenLoader />

  return (
    <>
      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        style={styles.fullWidthScrollView}
        contentContainerStyle={styles.contentContainer}
      >
        <DetailView aliasOrValias={aliasOrValias} />
      </ScrollView>
    </>
  )
}

function DetailView(props: { aliasOrValias: string }) {
  return (
    <>
      <GiveMoreDetails aliasOrValias={props.aliasOrValias} />
    </>
  )
}

